module.exports = __webpack_public_path__ + "static/img/76.27af11c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/76.jpg
// module id = Ea3P
// module chunks = 0